import { formatRawPhoneNumber } from '../../input/phone/utils/phoneNumberUtils';
import { usePropertyValue } from '../hooks/usePropertyValue';
import { getDataAttributes } from '../../utils/getDataAttributes';
import useComponentMountMetric from '../../metrics/useComponentMountMetric';
import { jsx as _jsx } from "react/jsx-runtime";
const FormattedPropertyPhone = props => {
  useComponentMountMetric('FormattedPropertyPhone');
  const propertyValue = usePropertyValue();
  const {
    placeholder
  } = props;
  return /*#__PURE__*/_jsx("span", Object.assign({}, getDataAttributes(props), {
    children: propertyValue ? formatRawPhoneNumber(propertyValue) : placeholder
  }));
};
FormattedPropertyPhone.displayName = 'FormattedPropertyPhone';
export default FormattedPropertyPhone;